/**
 * 此类可扩展为天时分秒的倒计时
 * 当前仅作为60s验证码倒计时
 */
import APP from '@/config/app.config'

export default class Countdown {
  timing = 0
  isRun = false
  // 保留倒计时数字
  keepTime = 0
  // 默认倒计时60s
  countTime = APP.COUNT_DOWN;

  setTime(t) {
    this.keepTime = t
    this.countTime = t
  }

  initialize(reset = false, time = APP.COUNT_DOWN) {
    if (!this.isRun) {
      this.setTime(time)
    } else if (reset) {
      this.cancel()
      this.isRun = false
      this.setTime(time)
    }
  }

  run(startFn, endFn) {
    this.cancel()
    this.isRun = true
    startFn(this.countTime)
    this.timing = setInterval(() => {
      if (this.countTime <= 1) {
        endFn()
        this.initialize(true, this.keepTime)
      } else {
        this.countTime--
        startFn(this.countTime)
      }
    }, 1000)
  }

  cancel() {
    if (this.timing) {
      clearInterval(this.timing)
      this.timing = 0
    }
  }
}
